import * as Yup from "yup";
import { validateMobileNumberServerSide } from "../Webshop/services/MobileNumberService";
import { getPortalCountryCode, validateSwishishPid } from "../utils";

const { locale } = window.NTLF_CONFIG.portal;

export const getYUPValidators = (t) => {
  const illegalCharacters = "(?!.*[@*•●])";
  return {
    FULL_NAME: Yup.string()
      .trim()
      .matches(
        new RegExp(`^${illegalCharacters}.*\\S{2,}.*\\s\\S{2,}.*$`),
        t("Minimum two parts, only characters allowed"),
      ),

    ADDRESS: Yup.string()
      .trim()
      .matches(
        new RegExp(`^${illegalCharacters}.*$`),
        t("Special characters are not allowed."),
      ),

    POSTAL_CODE: Yup.string()
      .trim()
      .matches(
        new RegExp(`^${illegalCharacters}[0-9A-z\\s\\-]{3,10}$`),
        t("Digits and/or letters, %d to %d characters.", {
          postProcess: "sprintf",
          sprintf: [3, 10],
        }),
      ),

    CITY: Yup.string()
      .trim()
      .matches(
        new RegExp(`^${illegalCharacters}.*$`),
        t("Special characters are not allowed."),
      ),

    PASSWORD: Yup.string().matches(
      /.{6,}/,
      t("The passwords must be atleast 6 characters long"),
    ),

    MOBILE_PHONE_WITH_SERVER_VALIDATION: Yup.string()
      .matches(
        /^\+{0,1}\d{7,16}$/,
        t("%d-%d digits", { postProcess: "sprintf", sprintf: [7, 14] }),
      )
      .test("is-valid-mobile", t("Invalid mobile number"), (value) => {
        // Empty value should be handled by "required"
        if (value === "" || typeof value === "undefined") {
          return true;
        }
        console.log("Validating mobile", value);
        return validateMobileNumberServerSide(value);
      })
      .transform((value) => value.replace(/[\s()-]+/g, "")),
    EMAIL_ADDRESS: Yup.string()
      .trim()
      .email(t("username@example.com"))
      // Don't allow user@example, it's confusing for the user when
      // buttons that wait for validation suddenly get enabled
      .matches(/.+@.+\..+$/, t("username@example.com")),

    // This need to support different languages:
    PERSONAL_ID_NUMBER_WITH_MIN_AGE: Yup.string()
      .test(function (value) {
        console.log("Validating personal number", value);
        const { path, createError } = this;
        if (!value) {
          if (locale.country.twoLetterCode === "SE") {
            return createError({
              path,
              message: t("Input format: %s", {
                postProcess: "sprintf",
                sprintf: ["YYMMDD-XXXX"],
              }),
            });
          }
          return createError({
            path,
            message: t("Invalid personal id number"),
          });
        }

        if (value === "0000") {
          return true;
        }

        if (locale.country.twoLetterCode === "SE") {
          const result = verifySwedishPid(value, t);
          if (result === true) {
            return true;
          } else {
            return createError({ path, message: result });
          }
        } else if (locale.country.twoLetterCode === "NO") {
          if (value.match(/^\d{11}$/)) {
            return true;
          }
        }
        // We don't really have a check here?
        else if (value.length > 3) {
          return true;
        }
        console.log("Invalid personal number, creating error", path);
        return createError({ path, message: t("Invalid personal id number") });
      })
      .test(
        "test-personal-number-age",
        t("You need to be at least 18 year to order"),
        (value) => {
          if (!value) {
            return false;
          }
          if (locale.country.twoLetterCode === "SE") {
            const res = validateSwishishPid(value);
            if (!res) {
              return false;
            } else if (res && res.age && res.age < 18) {
              return false;
            }
          }
          return true;
        },
      ),
  };
};

function verifySwedishPid(number, t) {
  number = number.replace(/-/g, "");
  console.log("Verify swedish number", number, number.length);
  if (number.match(/^\d{10}$/)) {
    let n = 2;
    // Kontrollsum
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      let tmp = number[i] * n;
      tmp > 9 ? (sum += 1 + (tmp % 10)) : (sum += tmp);
      n == 2 ? (n = 1) : (n = 2);
    }
    const total = sum + parseInt(number[9]);
    const valid = !(total % 10);
    if (valid) {
      return true;
    }
    return t("Input format: %s", {
      postProcess: "sprintf",
      sprintf: ["YYMMDD-XXXX"],
    });
  } else {
    return t("Input format: %s", {
      postProcess: "sprintf",
      sprintf: ["YYMMDD-XXXX"],
    });
  }
}
